import { render, staticRenderFns } from "./GroupedManuals.vue?vue&type=template&id=4c10463c"
import script from "./GroupedManuals.vue?vue&type=script&lang=js"
export * from "./GroupedManuals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports